module.exports = __webpack_public_path__ + "img/2_279.46de7e53.png";